"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "p-4 bg-white mb-3 w-full shadow"
};
const _hoisted_2 = { class: "table-auto w-full" };
const _hoisted_3 = {
    class: "text-xl py-3 text-left",
    colspan: "2"
};
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-document-edit" }, null, -1);
const _hoisted_5 = { class: "border-b-1 border-gray" };
const _hoisted_6 = { class: "py-3 text-left" };
const _hoisted_7 = { class: "text-right py-3 whitespace-nowrap" };
const _hoisted_8 = { class: "border-b-1 border-gray" };
const _hoisted_9 = { class: "text-right py-3 whitespace-nowrap" };
const _hoisted_10 = { class: "border-b-1 border-gray" };
const _hoisted_11 = { class: "text-right py-3 whitespace-nowrap" };
const _hoisted_12 = { class: "border-b-1 border-gray" };
const _hoisted_13 = { class: "text-right py-3 whitespace-nowrap" };
const _hoisted_14 = { class: "border-b-1 border-gray" };
const _hoisted_15 = { class: "text-right py-3 whitespace-nowrap" };
const _hoisted_16 = { class: "text-center pt-3 pr-3" };
const _hoisted_17 = {
    key: 0,
    class: "text-center pt-3"
};
const vue_3 = require("vue");
const securityStore_1 = require("../../stores/security/securityStore");
const i18n_1 = require("../../common/i18n");
const toastStore_1 = require("../../stores/toast/toastStore");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const balanceStore_1 = require("../../stores/balance/balanceStore");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BalanceCard',
    setup(__props) {
        const toastStore = (0, toastStore_1.useToastStore)();
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const balanceStore = (0, balanceStore_1.useBalanceStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const balance = (0, vue_3.computed)(() => balanceStore.balance);
        const shouldFetchBalance = (0, vue_3.computed)(() => {
            var _a;
            return securityStore.authenticatedUser !== null
                && balance.value === null
                && ((_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.hasPermission(PermissionEnum_1.UserPermissionEnum.BALANCE_READ));
        });
        (0, vue_3.onMounted)(async () => {
            var _a;
            if (shouldFetchBalance.value) {
                await balanceStore.getBalance(router, { id: (_a = securityStore.authenticatedUser) === null || _a === void 0 ? void 0 : _a.customer.id })
                    .catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
            }
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f;
            const _component_router_link = (0, vue_2.resolveComponent)("router-link");
            return ((0, vue_2.unref)(balance) !== null && ((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).BALANCE_READ)))
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("table", _hoisted_2, [
                        (0, vue_2.createElementVNode)("thead", null, [
                            (0, vue_2.createElementVNode)("tr", null, [
                                (0, vue_2.createElementVNode)("th", _hoisted_3, [
                                    _hoisted_4,
                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((_b = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _b === void 0 ? void 0 : _b.customer.name) + " " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("balance_first", "Balance", "balance_card")), 1)
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("tbody", null, [
                            (0, vue_2.createElementVNode)("tr", _hoisted_5, [
                                (0, vue_2.createElementVNode)("th", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(balance).currencyCode) + " " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("balance_second", "Balance", "balance_card")), 1),
                                (0, vue_2.createElementVNode)("th", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(balance).formattedTotal), 1)
                            ]),
                            (0, vue_2.createElementVNode)("tr", _hoisted_8, [
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("expired", "Expired", "balance_card")), 1),
                                (0, vue_2.createElementVNode)("td", _hoisted_9, (0, vue_2.toDisplayString)((_c = (0, vue_2.unref)(balance).formattedExpiredTotal) !== null && _c !== void 0 ? _c : (0, vue_2.unref)(i18n_1.trans)("no_data_available_expired", "No data available", "balance_card")), 1)
                            ]),
                            (0, vue_2.createElementVNode)("tr", _hoisted_10, [
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("not_due", "Not Due", "balance_card")), 1),
                                (0, vue_2.createElementVNode)("td", _hoisted_11, (0, vue_2.toDisplayString)((_d = (0, vue_2.unref)(balance).formattedNotDueTotal) !== null && _d !== void 0 ? _d : (0, vue_2.unref)(i18n_1.trans)("no_data_available_not_due", "No data available", "balance_card")), 1)
                            ]),
                            (0, vue_2.createElementVNode)("tr", _hoisted_12, [
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("full_credit_line", "Full Credit Line", "balance_card")), 1),
                                (0, vue_2.createElementVNode)("td", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(balance).formattedCustomerCreditMax), 1)
                            ]),
                            (0, vue_2.createElementVNode)("tr", _hoisted_14, [
                                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("remaining_credit_line", "Remaining Credit Line", "balance_card")), 1),
                                (0, vue_2.createElementVNode)("td", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(balance).formattedCustomerCreditRemaining), 1)
                            ]),
                            (0, vue_2.createElementVNode)("tr", null, [
                                (0, vue_2.createElementVNode)("td", _hoisted_16, [
                                    (0, vue_2.createVNode)(_component_router_link, {
                                        to: { name: 'queries_balance' },
                                        class: "btn btn-rounded btn-primary text-center !text-sm h-12"
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("detailed_balance", "Detailed Balance", "balance_card")), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                (((_e = (0, vue_2.unref)(currentUser)) === null || _e === void 0 ? void 0 : _e.hasPermission((0, vue_2.unref)(PermissionEnum_1.CouponPermissionEnum).COUPON_READ)) &&
                                    !((_f = (0, vue_2.unref)(currentUser)) === null || _f === void 0 ? void 0 : _f.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_17, [
                                        (0, vue_2.createVNode)(_component_router_link, {
                                            to: { name: 'queries_coupons' },
                                            class: "btn btn-rounded btn-success text-center !text-sm h-12"
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("coupons", "Coupons", "balance_card")), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ])
                    ])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
